import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
export default class PollImage extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "imageUrl", null);
    _defineProperty(this, "imageAlt", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.imageUrl = this.attrs.poll.imageUrl();
    this.imageAlt = this.attrs.poll.imageAlt();
  }
  view() {
    if (!this.imageUrl) {
      return;
    }
    return m("div", {
      className: "PollImage"
    }, this.imageItems().toArray());
  }
  imageItems() {
    var _this$imageAlt;
    const items = new ItemList();
    const srcset = this.attrs.poll.imageSrcset();
    items.add('image', m("img", {
      src: this.imageUrl,
      srcset: srcset != null ? srcset : undefined,
      alt: (_this$imageAlt = this.imageAlt) != null ? _this$imageAlt : '',
      className: "PollImage-image",
      loading: "lazy"
    }));
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollImage', PollImage);